// ============================================================================
// JAMB Learn Content — Mathematics
// Shared from WAEC learn bank (SS1+SS2+SS3 merged, no SS-level divisions shown)
// ============================================================================

import { WAEC_MATHEMATICS_LEARN_SS1 } from '../../waec/learn/ss1/mathematics';
import { WAEC_MATHEMATICS_LEARN_SS2 } from '../../waec/learn/ss2/mathematics';
import { WAEC_MATHEMATICS_LEARN_SS3 } from '../../waec/learn/ss3/mathematics';

export const JAMB_LEARN_MATHEMATICS = [
  ...WAEC_MATHEMATICS_LEARN_SS1,
  ...WAEC_MATHEMATICS_LEARN_SS2,
  ...WAEC_MATHEMATICS_LEARN_SS3,
];
